/**
 * Optimized Help Requests Management with Pagination and Caching
 */

import HelpRequestsManagement from './HelpRequestsManagement';
import withOptimization from '../../hoc/withOptimization';

export default withOptimization(HelpRequestsManagement, {
  collection: 'helpRequests',
  pageSize: 30,
  orderByField: 'createdAt',
  orderDirection: 'desc',
  cacheTTL: 3 * 60 * 1000
});

/**
 * Performance Improvements:
 * - Before: Loads ALL help requests (500+) = 8-12s load time
 * - After: Loads 30 requests at a time = 2-3s load time
 * - Firestore reads: 500+ → 30-150
 */
